//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs'
import breadCrumbs from '~/components/common/breadCrumbs.vue'
import wikiSelect from '~/components/common/wikiSelect.vue'
import breakpointCharts from '~/components/home/burst/breakpointCharts.vue'
import lineCharts from '~/components/home/burst/lineCharts.vue'
import pieCharts from '~/components/home/fundsFlowdatails/pieCharts.vue'
import { add, assign, matomofn } from '~/assets/js/utils.js'
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'wiki-select': wikiSelect,
    'breakpoint-charts': breakpointCharts,
    'line-charts': lineCharts,
    'pie-charts': pieCharts
  },
  async asyncData ({ store, $api }) {
    const { locale = 'en' } = store.state
    const [startTime, endTime] = [dayjs().subtract(1, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
    try {
      const [{ trendForLots = [] }, { tradeMomentum = [] }, { tradeCodeDistribution = [] }, { tradeRank = [] }, { updatetime = '' }] = await Promise.all([
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/trendForLots' }, { symbol: 'ALL', startTime, endTime }),
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/tradeMomentum' }, { startDate: startTime, endDate: endTime }),
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/tradeCodeDistribution' }, { startTime, endTime }),
        $api.common.invokeServer({ HttpMethodL: 'post', Route: '/mt4Extend/tradeRank' }, { sort: 'lots' }),
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/tradeTrend' }, { languageCode: locale, type: 'speed', symbol: 'EURUSD' })
      ])
      return {
        lineNumTrend: trendForLots?.reverse() || [],
        tradeMomentum: tradeMomentum?.reverse() || [],
        burstMoneyRate: tradeCodeDistribution || [],
        tradeRank: tradeRank || [],
        updateTime: updatetime
      }
    } catch (err) {}
  },
  data () {
    return {
      optionList: [ // 时间周期
        { label: 'TYY_000183', startTime: dayjs().subtract(1, 'month').format('YYYY-MM-DD') },
        { label: 'TYY_000182', startTime: dayjs().subtract(3, 'month').format('YYYY-MM-DD') },
        { label: '12766', startTime: dayjs().subtract(6, 'month').format('YYYY-MM-DD') },
        { label: 'TYY_000185', startTime: dayjs().subtract(12, 'month').format('YYYY-MM-DD') }
      ],
      selected: {}, // 时间周期选中项
      lineNumTrend: [], // 市场成交走势柱状图
      tradeMomentum: [], // 市场交易动能折线图
      burstMoneyRate: [], // 交易品种分布饼图
      pieColorArray: ['#6FC69F', '#E59460', '#3B76F6', '#8D81F3'], // 交易品种分布饼图颜色
      tradeRank: [], // 全球用户交易排行
      updateTime: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 更新时间
      pageEnterTime: null // 页面进入时间
    }
  },
  head () {
    return {
      title: this.$t('29343'),
      meta: [{ name: 'Description', content: this.$t('29344') }]
    }
  },
  created () {
    this.optionList?.forEach((item, index) => {
      item.value = add(index, 1)
      item.endTime = dayjs().format('YYYY-MM-DD')
    })
    this.selected = this.optionList[0]
  },
  mounted () {
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.trackPageTime)
  },
  beforeDestroy () {
    // 移除事件监听器
    window.removeEventListener('beforeunload', this.trackPageTime)
    // 执行页面时间统计
    this.trackPageTime()
  },
  methods: {
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const exitTime = Date.now()
        matomofn('Cloud_Trading_Quotes_Time', {
          af_Enter: this.pageEnterTime,
          af_Exit: exitTime
        }, this.$store.state, this.$cookies)
      }
    },
    // 切换时间周期时
    async changeOption (e = {}) {
      const { startTime = '', endTime = '', value = '' } = e || {}
      if (value == this.selected?.value) return false
      if (this.isRequest) return this.$toast.info(this.$t('16446')) // 操作过快请稍后再试
      assign(this.selected, e)
      try {
        this.isRequest = true
        const [{ trendForLots = [] }, { tradeMomentum = [] }, { tradeCodeDistribution = [] }, { tradeRank = [] }, { updatetime = '' }] = await Promise.all([
          this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/trendForLots' }, { symbol: 'ALL', startTime, endTime }), // 市场成交走势
          this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/tradeMomentum' }, { startDate: startTime, endDate: endTime }), // 市场交易动能
          this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/tradeCodeDistribution' }, { startTime, endTime }), // 交易品种分布
          this.$api.common.invokeClient({ HttpMethodL: 'post', Route: '/mt4Extend/tradeRank' }, { sort: 'lots' }), // 全球用户交易排行
          this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/tradeTrend' }, { languageCode: this.currLangCode(), type: 'speed', symbol: 'EURUSD' }) // 更新时间
        ])
        this.lineNumTrend = trendForLots?.reverse() || []
        this.tradeMomentum = tradeMomentum?.reverse() || []
        this.burstMoneyRate = tradeCodeDistribution || []
        this.tradeRank = tradeRank || []
        this.updateTime = updatetime
      } catch (err) {}
      this.isRequest = false
    }
  }
}
